import React from 'react'
import { StyledSubHeadingBCHomePage, StyledSubHeadingBCOtherPages } from './styled'

const SUB_HEADING_BC_TEXT = 'powered by Chegg'

export const SubHeadingBCHomePage = () => {
  return <StyledSubHeadingBCHomePage>{SUB_HEADING_BC_TEXT}</StyledSubHeadingBCHomePage>
}

export const SubHeadingBCRest = ({
  formPage,
  citationFD,
  fontSizeOverride,
}: {
  formPage?: boolean
  citationFD?: boolean
  fontSizeOverride?: string
}) => {
  return (
    <StyledSubHeadingBCOtherPages
      formPage={formPage}
      citationFD={citationFD}
      fontSizeOverride={fontSizeOverride}
    >
      {' '}
      - {SUB_HEADING_BC_TEXT}
    </StyledSubHeadingBCOtherPages>
  )
}
